import { tableImportMappingViewModel } from "@/models/importModels";
import api from "@/services/api";
import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";

@Component({})
export default class tableTypeConfig extends Vue {
	isLoading: boolean = false;
	isSaving: boolean = false;
	item: tableImportMappingViewModel = null;
	schemaFile: string[] = null;
	get tableName(): string {
		return this.$route && this.$route.params && this.$route.params.name ? this.$route.params.name : null;
	}
	get itemId(): number {
		let id = this.$route && this.$route.params && this.$route.params.id ? this.$route.params.id : null;

		let itemId = Number.parseInt(id);
		return isNaN(itemId) ? null : itemId;
	}

	@Watch("$route")
	onRouteChange(to, from) {
		var self = this;
		if (to.params.id != from.params.id) self.fetch();
	}
	get descrizioneState(): boolean {
		return null;
		// var self = this;
		// if (self.saveClicked == false || self.tableImportMapping == null)
		// 	return null;
		// return (
		// 	self.tableImportMapping.descrizione != null &&
		// 	self.tableImportMapping.descrizione.trim() != ""
		// );
	}
	get backPath(): string {
		var self = this;
		return `/settings-tables/${self.tableName}`;
	}
	get nameOfComponent() {
		var self = this;
		if (self.item && self.item.importType) return "import-config-" + self.item.importType.toString().toLowerCase();

		return null;
	}
	onDesrizioneKeyUp(event: KeyboardEvent) {
		var self = this;
		if (self.item != null && self.item.descrizione) {
			self.item.descrizione = self.item.descrizione.substr(0, 512);
		}
	}
	created() {
		var self = this;
		self.fetch();
	}
	fetch() {
		var self = this;

		api.getImportConfiguration(self.itemId)
			.then((res: tableImportMappingViewModel) => {
				self.item = res;
				self.fetchSchemaFile();

				if (self.item.hasSchemaChanged) {
					this.$bvToast.toast("Lo schema della tabella è cambiato! CONTROLLARE i valori default del mapping ed ESEGUIRE un salvataggio per confermare lo schema", {
						variant: "warning",
						title: "ATTENZIONE",
						solid: true
					});
				}
			})
			.finally(() => {
				// self.isLoading = false;
			});
	}
	fetchSchemaFile() {
		var self = this;

		if (self.item != null && self.item.schemaFile != null && self.item.schemaFile != "")
			api.getSchemaFile(self.itemId)
				.then((res: string[]) => {
					self.schemaFile = res;
				})
				.finally(() => {
					// self.isLoading = false;
				});
	}
	onRealTimeChange(realTime: boolean) {
		var self = this;
		if (self.item != null) self.item.realTime = realTime;
	}
	onSelectedFile(f: File) {
		var self = this;
		api.uploadSchemaFile(self.itemId, f)
			.then(res => {
				self.item.schemaFile = res;
				self.$bvToast.toast("Salvataggio effettuato corretamente", {
					variant: "success",
					title: "Caricamento file",
					solid: true
				});
				self.fetchSchemaFile();
			})
			.catch(error => {
				self.$bvToast.toast("Salvataggio non riuscito", {
					variant: "denger",
					title: "Errore caricamento file",
					solid: true
				});
			});
	}
	onSave() {
		var self = this;
		self.isSaving = true;
		api.postConfigDetail(self.item)
			.then((itemId: boolean) => {
				self.$bvToast.toast("Salvataggio effettuato corretamente", {
					variant: "success",
					title: "Salvataggio configurazione",
					solid: true
				});

				self.item.hasSchemaChanged = false;
			})
			.finally(() => {
				self.isSaving = false;
			});
	}

	onDelete() {
		var self = this;
		this.$bvModal
			.msgBoxConfirm(`Sei sicuro di eliminare la configurazione ${self.item.descrizione} ?`, {
				headerBgVariant: "warning",
				headerborderVariant: "warning",
				title: "ATTENZIONE",
				okTitle: "SI",
				okVariant: "warning",
				cancelTitle: "NO",
				footerClass: "p-2",
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if (value) {
					api.deleteTableConfig(self.item.itemID).then(res => {
						self.$router.push({
							path: `/settings-tables/${self.item.tableName}`
						});
					});
				}
			})
			.catch(err => {});
	}

	onDemandScheduleConfirm(set: tableImportMappingViewModel) {
		var self = this;
		this.$bvModal
			.msgBoxConfirm(`Sei sicuro di voler eseguire ORA l'importazione di questa configurazione?`, {
				title: "ATTENZIONE",
				okTitle: "SI",
				cancelTitle: "NO",
				footerClass: "p-2",
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if (value) {
					api.executeOnDemandSettings(set.itemID).then(res => {
						this.$bvToast.toast("L'importazione è in fase di avviamento", {
							variant: "success",
							title: "Operazione eseguita",
							solid: true
						});

						Vue.set(set, "isOnProgressImport", true);

						setTimeout(function() {
							set.isOnProgressImport = false;
						}, 5000)
					});
				}
			})
			.catch(err => {});

		return false;
	}
}
